<template>
  <div class="container-fluid">
    <Card>
      <template slot="header">
        <h3>گزارش تماسها</h3>
        <hr />
      </template>
      <template slot="content">
        <div class="container-fluid">
          <div class="row" :id="'VlidThis'">
            <div class="col-lg-4 col-12">
              <small id="LblUserId">تمـاس گیــرنده</small>
              <SearchableCombo :edit="false" :grp="0" :code="null" @ResultCombo="GetResulUserId" :rownumintable="3" :action="'TblCrmCombo/GetUserDatails'" :method="'POST'" :idinput="'UserId'" :keyItem="'UserId'" :disabled="false" :ClassProps="'required'"> </SearchableCombo>
            </div>
            <div class="col-lg-4 col-12">
              <div v-if="MDReport">
                <small id="LbltarixAz"> از تاریخ تا تاریخ</small>
                <date-picker color="dimgray" range v-model="tarix" clearable :editable="true" placeholder=" تاریخ "></date-picker>
              </div>
            </div>
            <div class="col-lg-2 col-12">
              <small id="LbltarixAz"> گزارش روزانه/ماهانه</small>
              <div class="custom-control custom-switch">
                <input type="checkbox" class="custom-control-input InputText" id="Done" v-model="MDReport" />
                <label class="custom-control-label" for="Done"> </label>
              </div>
            </div>
            <div class="col-lg-2 col-12">
              <button v-if="MDReport" :disabled="disabelButton" class="btn btn-success w-100 mt-4" @click="Search()">ساخت گزارش روزانه</button>
              <button v-else :disabled="disabelButton" class="btn btn-success w-100 mt-4" @click="SearchMonthly()">ساخت گزارش ماهانه</button>
            </div>
            <div class="col-lg-6 col-12">
              <div v-if="Allrows.length > 0">
                <div v-if="MDReport">
                  <small>اضافه کردن کاربر دیگر برای مقایسه</small>
                  <SearchableCombo :edit="false" :grp="0" :code="null" @ResultCombo="GetResulUserIdCompare" :rownumintable="3" :action="'TblCrmCombo/GetUserDatails'" :method="'POST'" :idinput="'UserIdd'" :keyItem="'UserIdd'" :disabled="false"> </SearchableCombo>
                </div>
              </div>
              <div v-if="!MDReport && ChartDataMonth.length > 0">
                <small>اضافه کردن کاربر دیگر برای مقایسه ماهانه</small>
                <SearchableCombo :edit="false" :grp="0" :code="null" @ResultCombo="GetResulUserIdCompareMonth" :rownumintable="3" :action="'TblCrmCombo/GetUserDatails'" :method="'POST'" :idinput="'UserIdd'" :keyItem="'UserIdd'" :disabled="false"> </SearchableCombo>
              </div>
            </div>
            <div class="col-lg-4 col-12"></div>
            <div class="col-lg-2 col-12">
              <button v-if="MDReport" class="btn btn-success w-100 mt-4" @click="Chart()">مشاهده نمودار <i class="fad fa-chart-line"></i></button>
            </div>
          </div>

          <div v-if="MDReport">
            <div class="row" v-if="ChartShow && Allrows.length > 0">
              <MCChart v-if="$store.state.renderComponentGrid" :data="ChartData"></MCChart>
            </div>
            <div v-else class="row">
              <div class="col-12">
                <BnpGrid v-if="$store.state.renderComponentGrid" :hasRowNum="true" :propsColumn="Column" :propsRows="Allrows" :Selectable="false" :action="false">
                  <template slot="tblComboGrp24Resultname" slot-scope="props">
                    <span>
                      <div :data-title="props.props.tblComboGrp24Resultname">
                        <h4 v-if="props.props.tblComboGrp24Result == 1351" class="fad fa-phone-volume text-warning" :data-title="props.props.tblComboGrp24Resultname"></h4>
                      </div>
                      <div :data-title="props.props.tblComboGrp24Resultname">
                        <h4 v-if="props.props.tblComboGrp24Result == 1352" class="fad fa-phone text-danger" :data-title="props.props.tblComboGrp24Resultname"></h4>
                      </div>
                      <div :data-title="props.props.tblComboGrp24Resultname">
                        <h4 v-if="props.props.tblComboGrp24Result == 1353" class="fad fa-user-alt-slash text-warning" :data-title="props.props.tblComboGrp24Resultname"></h4>
                      </div>
                      <div :data-title="props.props.tblComboGrp24Resultname">
                        <h4 v-if="props.props.tblComboGrp24Result == 1354" class="fad fa-phone-volume text-success"></h4>
                      </div>
                      <div :data-title="props.props.tblComboGrp24Resultname">
                        <h4 v-if="props.props.tblComboGrp24Result == 1355" class="fas fa-envelope-open-text text-light" :data-title="props.props.tblComboGrp24Resultname"></h4>
                      </div>
                      <div :data-title="props.props.tblComboGrp24Resultname">
                        <h4 v-if="props.props.tblComboGrp24Result == 1356" class="fas fa-fax text-light" :data-title="props.props.tblComboGrp24Resultname"></h4>
                      </div>
                      <div :data-title="props.props.tblComboGrp24Resultname">
                        <h4 v-if="props.props.tblComboGrp24Result == 1357" class="fas fa-paper-plane text-primary" :data-title="props.props.tblComboGrp24Resultname"></h4>
                      </div>
                      <div :data-title="props.props.tblComboGrp24Resultname">
                        <h4 v-if="props.props.tblComboGrp24Result == 1365" class="fad fa-phone-slash text-danger" :data-title="props.props.tblComboGrp24Resultname"></h4>
                      </div>
                      <div :data-title="props.props.tblComboGrp24Resultname">
                        <h4 v-if="props.props.tblComboGrp24Result == 1366" class="fad fa-power-off text-danger" :data-title="props.props.tblComboGrp24Resultname"></h4>
                      </div>
                      <div :data-title="props.props.tblComboGrp24Resultname">
                        <h4 v-if="props.props.tblComboGrp24Result == 1372" class="fad fa-signal text-danger" :data-title="props.props.tblComboGrp24Resultname"></h4>
                      </div>
                      <div :data-title="props.props.tblComboGrp24Resultname">
                        <h4 v-if="props.props.tblComboGrp24Result == 1377" class="fas fa-images text-light" :data-title="props.props.tblComboGrp24Resultname"></h4>
                      </div>
                      <div :data-title="props.props.tblComboGrp24Resultname">
                        <h4 v-if="props.props.tblComboGrp24Result == 1378" class="fad fa-ban text-danger" :data-title="props.props.tblComboGrp24Resultname"></h4>
                      </div>
                      <div :data-title="props.props.tblComboGrp24Resultname">
                        <h4 v-if="props.props.tblComboGrp24Result == 1386" class="fas fa-mailbox text-light" :data-title="props.props.tblComboGrp24Resultname"></h4>
                      </div>
                      <div :data-title="props.props.tblComboGrp24Resultname">
                        <h4 v-if="props.props.tblComboGrp24Result == 1447" class="fas fa-desktop text-light" :data-title="props.props.tblComboGrp24Resultname"></h4>
                      </div>
                      <div :data-title="props.props.tblComboGrp24Resultname">
                        <h4 v-if="props.props.tblComboGrp24Result == 1465" class="fas fa-sms text-success" :data-title="props.props.tblComboGrp24Resultname"></h4>
                      </div>
                      <div :data-title="props.props.tblComboGrp24Resultname">
                        <h4 v-if="props.props.tblComboGrp24Result == 1466" class="fas fa-2x fa-ellipsis-h text-light" :data-title="props.props.tblComboGrp24Resultname"></h4>
                      </div>
                    </span>
                  </template>
                </BnpGrid>
              </div>
            </div>
          </div>
          <div v-else>
            <div class="row">
              <MCCMonth v-if="$store.state.renderComponentGrid" :data="ChartDataMonth"></MCCMonth>
            </div>
          </div>
        </div>
      </template>
    </Card>
  </div>
</template>
<script>
import Card from '@/components/Card/Card.vue'
import SearchableCombo from '@/components/Combo/SearchableCombo.vue'
import VuePersianDatetimePicker from 'vue-persian-datetime-picker'
import BnpGrid from '@/components/BnpGrid/BnpGrid.vue'
import MCChart from './Components/MCChart.vue'
import MCCMonth from './Components/MCCMonth.vue'

export default {
  data() {
    return {
      ArrCompareData: [],
      ArrCompareDataMonth: [],
      ChartShow: false,
      tarix: [],
      DataAxiosSearch: {
        Method: 'POST',
        Action: 'Reports/MarketerCalls',
        ArryfildValue: {
          startDate: '',
          endDate: '',
          tblUserId: '',
        },
      },
      DataAxoisCol: {
        ArryfildValue: {
          SoftwareId: 2,
          UserId: 1,
          FormName: 'frmCommunications',
          ShowView: 0,
        },
        Method: 'post',
        Action: 'ReadGridColumns',
      },
      ChartData: [],
      ChartDataMonth: [],
      Column: [],
      Allrows: [],
      SearchName: '',
      disabelButton: false,
      //true = daily --- false = monthly
      MDReport: true,
    }
  },
  components: { datePicker: VuePersianDatetimePicker, Card, SearchableCombo, BnpGrid, MCChart, MCCMonth },
  methods: {
    GetResulUserId(data) {
      this.DataAxiosSearch.ArryfildValue.tblUserId = Number(data.id)
      this.SearchName = data.name
    },
    GetResulUserIdCompare(data) {
      if (data.id == null) {
        return null
      }
      if (this.ArrCompareData.indexOf(data.id) != -1) {
        this.$toasted.error('کاربر تکراری', {
          duration: 2000,
        })
        return null
      } else {
        this.ArrCompareData.push(data.id)
      }
      var axiosCompare = JSON.parse(JSON.stringify(this.DataAxiosSearch))
      axiosCompare.ArryfildValue.tblUserId = data.id
      axiosCompare.ArryfildValue.startDate = this.tarix[1] ? this.tarix[1] : null
      axiosCompare.ArryfildValue.endDate = this.tarix[0] ? this.tarix[0] : null
      this.$PostData(axiosCompare).then((result) => {
        this.BuildChartData(result.data, data.name)
        this.$store.state.renderComponentGrid = false
        this.$nextTick(() => {
          this.$store.state.renderComponentGrid = true
          document.getElementById('UserIdd').value = ''
        })
      })
    },
    Search() {
      this.disabelButton = true
      this.ChartData = []
      this.ArrCompareData = [this.DataAxiosSearch.ArryfildValue.tblUserId]
      if (this.$ValidForm('VlidThis')) {
        this.DataAxiosSearch.ArryfildValue.startDate = this.tarix[1] ? this.tarix[1] : null
        this.DataAxiosSearch.ArryfildValue.endDate = this.tarix[0] ? this.tarix[0] : null
        this.$PostData(this.DataAxiosSearch)
          .then((result) => {
            this.Allrows = result.data
            this.BuildChartData(result.data, this.SearchName)
            this.$store.state.renderComponentGrid = false
            this.$nextTick(() => {
              this.$store.state.renderComponentGrid = true
            })
          })
          .finally(() => {
            this.disabelButton = false
          })
      }else{
              this.disabelButton = false

      }
    },
    BuildChartData(list, name) {
      var dates = []
      list.forEach((element) => {
        dates.push(element.Date)
      })
      var months = []
      dates.forEach((date) => {
        months.push(date.slice(5, 7))
      })
      months = months.filter(this.onlyUnique)
      months.sort((a, b) => {
        if (a < b) {
          return -1
        }
        if (a > b) {
          return 1
        }
        return 0
      })
      var MainDates = []
      var temp = []

      months.forEach((month) => {
        if (Number(month) < 7) {
          for (let index = 1; index < 32; index++) {
            MainDates.push(dates[0].slice(0, 5) + month + '/' + (Number(index) > 9 ? index : '0' + index))
          }
        } else {
          for (let index = 0; index < 31; index++) {
            MainDates.push(dates[0].slice(0, 5) + month + '/' + (Number(index) > 9 ? index : '0' + index))
          }
        }
        MainDates.splice(MainDates.indexOf(this.DataAxiosSearch.ArryfildValue.startDate), MainDates.length)
        MainDates.splice(0, MainDates.indexOf(this.DataAxiosSearch.ArryfildValue.endDate))
        MainDates.forEach((date) => {
          var Count = list.filter((x) => x.Date == date).length
          temp.push({ date, Count, name })
        })
      })

      this.ChartData.push(temp)
    },
    onlyUnique(value, index, self) {
      return self.indexOf(value) === index
    },
    Chart() {
      this.ChartShow = !this.ChartShow
    },
    SearchMonthly() {
      this.ChartDataMonth = []
      this.ArrCompareDataMonth = [this.DataAxiosSearch.ArryfildValue.tblUserId]
      var DataAxiosMonth = { Action: 'Reports/MarketerCallsByMonth', Method: 'POST', ArryfildValue: this.DataAxiosSearch.ArryfildValue }
      this.$PostData(DataAxiosMonth).then((result) => {
        var ExistingMonths = []
        result.data.forEach((element) => {
          ExistingMonths.push(element.months)
        })
        var AllMonths = ['01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12']
        AllMonths.forEach((month) => {
          if (ExistingMonths.indexOf(month) == -1) {
            result.data.push({ months: month, CallCount: 0 })
          }
        })
        result.data.sort((a, b) => {
          if (a.months < b.months) {
            return -1
          }
          if (a.months > b.months) {
            return 1
          }
          return 0
        })

        result.data.forEach((element) => {
          switch (element.months) {
            case '01':
              element.months = 'فروردین'
              break
            case '02':
              element.months = 'اردیبهشت'
              break
            case '03':
              element.months = 'خرداد'
              break
            case '04':
              element.months = 'تیر'
              break
            case '05':
              element.months = 'مرداد'
              break
            case '06':
              element.months = 'شهریور'
              break
            case '07':
              element.months = 'مهر'
              break
            case '08':
              element.months = 'آبان'
              break
            case '09':
              element.months = 'آذر'
              break
            case '10':
              element.months = 'دی '
              break
            case '11':
              element.months = 'بهمن'
              break
            case '12':
              element.months = 'اسفند'
              break
          }
          element.name = this.SearchName
        })
        this.ChartDataMonth.push(result.data)
        this.$store.state.renderComponentGrid = false
        this.$nextTick(() => {
          this.$store.state.renderComponentGrid = true
          document.getElementById('UserIdd').value = ''
        })
      })
    },
    GetResulUserIdCompareMonth(data) {
      if (data.id == null) {
        this.$toasted.error('کاربر تکراری', {
          duration: 2000,
        })
        return null
      }
      if (this.ArrCompareDataMonth.indexOf(data.id) != -1) {
        return null
      } else {
        this.ArrCompareDataMonth.push(data.id)
      }
      var DataAxiosMonth = { Action: 'Reports/MarketerCallsByMonth', Method: 'POST', ArryfildValue: this.DataAxiosSearch.ArryfildValue }
      DataAxiosMonth.ArryfildValue.tblUserId = data.id
      this.$PostData(DataAxiosMonth).then((result) => {
        var ExistingMonths = []
        result.data.forEach((element) => {
          ExistingMonths.push(element.months)
        })
        var AllMonths = ['01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12']
        AllMonths.forEach((month) => {
          if (ExistingMonths.indexOf(month) == -1) {
            result.data.push({ months: month, CallCount: 0 })
          }
        })
        result.data.sort((a, b) => {
          if (a.months < b.months) {
            return -1
          }
          if (a.months > b.months) {
            return 1
          }
          return 0
        })

        result.data.forEach((element) => {
          switch (element.months) {
            case '01':
              element.months = 'فروردین'
              break
            case '02':
              element.months = 'اردیبهشت'
              break
            case '03':
              element.months = 'خرداد'
              break
            case '04':
              element.months = 'تیر'
              break
            case '05':
              element.months = 'مرداد'
              break
            case '06':
              element.months = 'شهریور'
              break
            case '07':
              element.months = 'مهر'
              break
            case '08':
              element.months = 'آبان'
              break
            case '09':
              element.months = 'آذر'
              break
            case '10':
              element.months = 'دی '
              break
            case '11':
              element.months = 'بهمن'
              break
            case '12':
              element.months = 'اسفند'
              break
          }
          element.name = data.name
        })
        this.ChartDataMonth.push(result.data)
        this.$store.state.renderComponentGrid = false
        this.$nextTick(() => {
          this.$store.state.renderComponentGrid = true
          document.getElementById('UserIdd').value = ''
        })
      })
    },
  },
  beforeMount() {
    this.$GetColumns(this.DataAxoisCol, true)
      .then((data) => {
        this.Column = data
        this.Column[6].visibility = false
        this.Column.push({ name: 'CustomerName', label: 'نام مشتری', visibility: true })
      })
      .finally(() => {
        this.$store.state.renderComponentGrid = false
        this.$nextTick(() => {
          this.$store.state.renderComponentGrid = true
        })
      })
  },
}
</script>
